import styled from 'styled-components';

const StyledInsightText = styled.div`
  margin-left: 0.5rem;
  margin-right: auto;
`;

const StyledIconWrapper = styled.div`
  margin-right: 1.5rem;
`;
const StyledInsight = styled.div<{ $opened: boolean }>`
  position: relative;
  border: 1px solid ${(props) => (props.$opened ? props.theme.color.primary : props.theme.color.borderColor)};
  transition: border 0.2s ease-in-out;
  border-radius: ${(props) => props.theme.radius.md};
  width: 250px;
  height: fit-content;
  padding: 0.5rem 1.5rem;

  &:hover {
    border: 1px solid ${(props) => props.theme.color.primary};
    cursor: pointer;
  }
`;

const StyledInsightHeader = styled.div`
  height: 70px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
`;

const StyledInsightDescription = styled.div<{ $opened: boolean }>`
  max-height: ${(props) => (props.$opened ? '400px' : '0px')};
  overflow: hidden;
  transition: max-height 0.4s ease-in-out;
`;

const StyledUnfoldButton = styled.div<{ $opened: boolean }>`
  transform: rotate(${(props) => (props.$opened ? '0deg' : '180deg')});
  transition: transform 0.2s ease-in-out;

  & > svg {
    transition: scale 0.2s ease-in-out;
    scale: 1;
    &:hover {
      scale: 1.2;
    }
  }
`;

export {
  StyledInsight,
  StyledInsightHeader,
  StyledInsightText,
  StyledIconWrapper,
  StyledInsightDescription,
  StyledUnfoldButton,
};
